
<!-- Success/Failure Alert modals (desktop) -->
<ng-container *ngIf="showAlertModal">
  <ng-container *ngIf="!isMobile else mobileAlerts">
    <app-web-kamona-message-widget
    [modalType]="ModalType.CUSTOM"
    (emitCancel)="handleCloseModal" 
    >
      <ng-container *ngTemplateOutlet="modalAlertContent">
      </ng-container>
    </app-web-kamona-message-widget>
  </ng-container>
</ng-container>

<!-- Success/Failure Alert modals (mobile) -->
<ng-template #mobileAlerts>
  <app-mobile-kamona-message-widget
  [modalType]="ModalType.CUSTOM"
  (emitCancel)="handleCloseModal" 
  >
    <ng-container *ngTemplateOutlet="modalAlertContent">
    </ng-container>
  </app-mobile-kamona-message-widget>
</ng-template>

<!-- Success/Failure Alert template (content) -->
<ng-template #modalAlertContent>
  <ng-container *ngIf="showAlertModal === ALERT_VARIANTS.SUCCESS">
    <ng-container *ngTemplateOutlet="successTemplate"></ng-container>
  </ng-container>

  <ng-container *ngIf="showAlertModal === ALERT_VARIANTS.FAILURE">
    <ng-container *ngTemplateOutlet="failureTemplate"></ng-container>
  </ng-container>
</ng-template>

<!-- Privacy Alert modals -->
<ng-container *ngIf="showPrivacyModal">
  <ng-container *ngIf="!isMobile else mobilePrivacyContent">
    <app-web-kamona-message-widget
    [modalType]="ModalType.CUSTOM"  
    >
      <ng-container *ngTemplateOutlet="privacyTemplate"></ng-container>
    </app-web-kamona-message-widget>
  </ng-container>
</ng-container>

<!-- Privacy Alert modals (mobile) -->
<ng-template #mobilePrivacyContent>
  <app-mobile-kamona-message-widget
  [modalType]="ModalType.CUSTOM"
  (emitCancel)="handleCloseModal" 
  >
    <ng-container *ngTemplateOutlet="privacyTemplate">
    </ng-container>
  </app-mobile-kamona-message-widget>
</ng-template>

<!-- Terms and Conditions Alert modals -->
<ng-container *ngIf="showTermsModal">
  <ng-container *ngIf="!isMobile else mobileTermsContent">
    <app-web-kamona-message-widget
    [modalType]="ModalType.CUSTOM"
    >
      <ng-container *ngTemplateOutlet="termsAndConditionsTemplate"></ng-container>
    </app-web-kamona-message-widget>
  </ng-container>
</ng-container>

<!-- Terms and Conditions Alert modals (mobile) -->
<ng-template #mobileTermsContent>
  <app-mobile-kamona-message-widget
  [modalType]="ModalType.CUSTOM"
  (emitCancel)="handleCloseModal" 
  >
    <ng-container *ngTemplateOutlet="termsAndConditionsTemplate">
    </ng-container>
  </app-mobile-kamona-message-widget>
</ng-template>


<div class="liveness-check-wrapper min-h-screen p-[20px] bg-[#f5f5f5]">
    <ng-container *ngTemplateOutlet="header"></ng-container>

    <ng-container *ngIf="isOTPFlow else faceVerificationBody">
      <ng-container *ngTemplateOutlet="otpBody"></ng-container>
    </ng-container>

    <ng-container *ngIf="isVerifyingOTP || isSubmitting || isResendingOTP">
      <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
    </ng-container>

    <ng-container *ngTemplateOutlet="footer"></ng-container>
</div>


<ng-template #header>
	<div class="w-full flex flex-col md:flex-row justify-between md:items-center max-w-[1196px] mx-auto">
		<img src="assets/images/svgs/moniepoint-icon-and-label.svg" class="max-w-[240px] md:max-w-full">
	</div>
</ng-template>


<ng-template #faceVerificationBody>
  <div class="body-wrapper max-w-[560px] mx-auto mt-[20px]" data-test-id="face-aml-body">
    <ng-container *ngIf="livenessStep === VERIFICATION_STEPS.INSTRUCTIONS">
      <ng-container *ngTemplateOutlet="verificationInstructions"></ng-container>
    </ng-container>
      

   <ng-container *ngIf="livenessStep === VERIFICATION_STEPS.VERIFICATION">
    <ng-container
    *ngTemplateOutlet="livelinessTemplate"
    ></ng-container>
  </ng-container>
  </div>
</ng-template>


<ng-template #otpBody>
  <div class="body-wrapper max-w-[480px] mx-auto mt-[42px]" data-test-id="otp-aml-body">
    <div class="bg-white rounded-2xl p-8 text-center flex flex-col items-center gap-3">
      <img src="assets/images/info.svg" class="w-[56px] h-[56px]">
    
      <app-web-kamona-otp-widget
        (emitBack)="goBack()"
        (emitSubmit)="verifyWithOTP($event)"
        (emitReload)="handleReloadOTP($event)"
        [ussd]="otpResponse?.ussdCode"
        [currentOtpMode]="currentOTPMode || currentOtpModes?.SMS_MODE"
        [canUseWhatsappOTPResend]="useResendOtpViaWhatsapp"
        [canUseSmsOTPResend]="useResendOtpViaSms"
        [canUseNewUssd]="canUseNewUssd"
        [hasResendButtonCountdown]="false"
        [showBothCountDown]="showBothCountDown"
        [description]="otpResponse?.message || 'We’ve just sent you a 6 digit code. Check your messages and enter it here.'"
        btnText="Continue"
        title="Continue with your OTP"
        class="max-w-[400px]"
      ></app-web-kamona-otp-widget>
    </div>
  </div>
</ng-template>


<ng-template #footer>
	<div class="max-w-[939px] mx-auto w-full text-[14px] font-medium text-[#808080] leading-[17.36px] flex flex-col md:flex-row gap-6 md:gap-0 mb-9 md:mb-0 justify-between">
    <div class="flex gap-[16px] basis-1/2">
      <span class="cursor-pointer" (click)="openPrivacy()">Privacy</span>
      <span class="cursor-pointer" (click)="openTermsAndConditions()">Terms & Conditions</span>
    </div>
	</div>
</ng-template>


<ng-template #livelinessTemplate>
  <div class="bg-white rounded-2xl p-8">
    <ng-container *ngIf="uploadImageLoader">
        <div class="my-8">
          <app-kamona-loading loadingText="Loading...">
          </app-kamona-loading>
        </div>
    </ng-container>

    <ng-container *ngIf="isSubmitting">
      <div class="w-full h-full items-center my-8">
        <div *ngIf="countDownTime" class="mx-auto w-[158px]">
          <app-time-line-progress [currentTime]="getCurrentTime()" [isTimerHidden]="canHideTimerCount()"
            [minute]="getRefinedTime(countDownTime?.minutes)"
            [second]="getRefinedTime(countDownTime?.seconds)" [size]="158" [strokeWidth]="8"
            [totalTime]="TOTAL_TIME_IN_SEC" [type]="ProgressTimelineType.TIMER">
          </app-time-line-progress>
        </div>
        <div class="mt-[17px] flex justify-center">
          <div *ngIf="!canHideTimerCount()"
            class="text-[18px] text-center leading-[25px] text-black font-bold">
            <div>Verifying your Identity,</div>
            <div>please hold on...</div>
          </div>
          <div *ngIf="canHideTimerCount()"
            class="text-[18px] text-center leading-[25px] text-black font-bold">
            <div>This may take a while,</div>
            <div>please hold on...</div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!isSubmitting && !uploadImageLoader">
      <app-kamona-smile-id (emitImage)="handleEmitImage($event)">
      </app-kamona-smile-id>

      <div class="mt-6 flex justify-center">
        <app-custom-button state="lightsecondary" text="Cancel"
        (click)="cancelLiveLiness()"
        ></app-custom-button>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #verificationInstructions>
  <div class="instructions bg-white rounded-2xl p-8">
    <img src="assets/images/verify-identity.svg" class="w-full" />

    <div class="mt-6 mb-7 text-center">
      <h4 class="font-bold text-[28px] leading-[34.72px] mb-2 max-w-[335px] mx-auto">Verify your identity before proceeding</h4>
      <p class="text-[12px] leading-[17.76px] max-w-[450px] mx-auto">We&apos;ve observed some new activity on your account and would like to confirm that it&apos;s really you before continuing.</p>
    </div>

    <div class="border border-[#f2f3f3] rounded-2xl p-4 mb-10">
      <p class="font-medium text-[12px] text-[#666] leading-[17.76px] mb-3">We recommend that you . . .</p>

      <ul class="m-0 p-0 flex flex-col gap-3 font-medium text-[#808080] text-[12px] leading-[17.76px] [&>li]:flex [&>li]:items-center [&>li]:gap-4">
        <li>
          <img class="w-[36px] h-[36px]" src="assets/images/card-light-bulb.svg" />

          <span>Stay in a brightly lit environment</span>
        </li>

        <li>
          <img class="w-[36px] h-[36px]" src="assets/images/card-glasses.svg" />

          <span>Remove glasses, hats, hijabs, face masks or any other face coverings</span>
        </li>

        <li>
          <img class="w-[36px] h-[36px]" src="assets/images/card-info.svg" />

          <span>Follow the on-screen instructions during face capture</span>
        </li>
      </ul>
    </div>

    <div>
      <app-custom-button type="primary" text="Start Face Verification Now" class="w-full"
      data-test-id="face-aml-button"
      (click)="startLiveliness()"
      ></app-custom-button>
    </div>
  </div>
</ng-template>


<ng-template #termsAndConditionsTemplate>
	<ng-container>
		<div class="flex flex-col gap-[24px] -mb-[8px]">
			<div class="flex flex-col gap-[8px]">
				<div class="leading-[29.76px] font-bold text-[24px] text-[#1A1A1A]">
					Terms and Conditions
				</div>
				<div class="leading-[19.6px] font-normal text-[14px] text-[#1A1A1A]">
					Please read through carefully
				</div>
			</div>
			<div class="overflow-y-scroll max-h-[475px]" id="terms-and-condition-content" [innerHTML]="termsAndConditions?.content"></div>
			<div class="flex items-center justify-center">
				<div (click)="handleCloseTermsModal()" class="bg-[#E6EEFD] w-[335px] cursor-pointer items-center h-[48px] gap-[4px] py-[6px] px-[16px] flex justify-center rounded-[8px]">
					<div class="text-[#0361F0] text-[14px] font-medium leading-[17.36px]">Close</div>
				</div>
			</div>
		</div>
	</ng-container>
</ng-template>

<ng-template #privacyTemplate>
	<ng-container>
		<div class="flex flex-col gap-[24px] -mb-[8px]">
			<div class="flex flex-col gap-[8px]">
				<div class="leading-[29.76px] font-bold text-[24px] text-[#1A1A1A]">
					Privacy Policy
				</div>
				<div class="leading-[19.6px] font-normal text-[14px] text-[#1A1A1A]">
					Please read through carefully
				</div>
			</div>
			<div class="overflow-y-scroll max-h-[475px]">
				<app-privacy></app-privacy>
			</div>
			<div class="flex items-center justify-center">
				<div (click)="handleClosePrivacyModal()" class="bg-[#E6EEFD] w-[335px] cursor-pointer items-center h-[48px] gap-[4px] py-[6px] px-[16px] flex justify-center rounded-[8px]">
					<div class="text-[#0361F0] text-[14px] font-medium leading-[17.36px]">Close</div>
				</div>
			</div>
		</div>
	</ng-container>
</ng-template>


<ng-template #successTemplate>
  <div class="flex flex-col pt-[24px] px-[16px] gap-[32px]">
		<div class="flex justify-center">
			<img src="assets/images/svgs/alert-success.svg" class="w-[126px] h-[126px]" />
		</div>

    <h3 class="leading-[28px] text-black text-[24px] font-bold text-center">{{isOTPFlow ? 'OTP' : 'Identity'}} Verification Completed</h3>

		<div class="pt-[20px] flex items-center">
        <app-custom-button type="primary" text="Continue to Dashboard" 
        (click)="handleVerificationSuccess()"
        class="w-full"
        ></app-custom-button>
		</div>
	</div>
</ng-template>

<ng-template #failureTemplate>
  <div class="flex flex-col pt-[24px] px-[16px] gap-[32px]">
		<div class="flex justify-center">
      <img src="assets/images/svgs/error-lg.svg" class="w-[126px] h-[126px]" />
		</div>

    <h3 class="leading-[28px] text-black text-[24px] font-bold text-center">{{isOTPFlow ? "OTP" : "Identity"}} Verification Failed</h3>
    <p class="text-center">{{alertErrorMessage || "Something went wrong. Please try again."}}</p>

		<div class="pt-[20px] flex flex-col gap-6 items-center">
      <app-custom-button type="primary" text="Try again" class="w-full"
      (click)="handleVerificationFailure()"
      ></app-custom-button>
		</div>
	</div>
</ng-template>


<ng-template #loadingTemplate>
  <div class="absolute top-0 left-0 min-w-full min-h-screen backdrop-blur-[7px] bg-[#00000080]">
    <div class="vertically-centralized">
      <app-kamona-loading loadingType="SPINNER"
      stroke="#FFFFFF" parentHeight="40"
      ></app-kamona-loading>
      <p class="text-center text-lg font-bold leading-[24.48px] mt-1 text-white">
        <span *ngIf="isVerifyingOTP || isSubmitting">
          Verifying your {{isVerifyingOTP ? 'OTP' : 'Identity'}},
        </span> 
        Please hold on...
      </p>
    </div>
  </div>
</ng-template>



